module.exports = __webpack_public_path__ + "static/beerlanding-60c46b559d27932ed318c5fd265f65b5.png";